module.exports = __webpack_public_path__ + "media/es_slide19_audio.980f4f47.mp4";